import { useRef, useEffect } from 'react';
import { ECharts } from 'echarts';
import * as echarts from 'echarts';

interface ChartProps {
  option: echarts.EChartsOption,
}

export type ChartOption = echarts.EChartsOption

export const Chart: React.FC<ChartProps> = ({ option }) => {
  const chartRef = useRef<HTMLDivElement | null>(null);
  let chartInstance: ECharts | null = null;

  useEffect(() => {
    if (chartRef.current) {
      chartInstance = echarts.init(chartRef.current);
      chartInstance.setOption(option);
    }
    return () => {
      chartInstance && chartInstance.dispose();
    };
  }, [option]);

  return (
    <div
      ref={chartRef}
      style={{ width: '100%', height: '100%' }}
    ></div>
  );
};